import { render, staticRenderFns } from "./WriteStep.vue?vue&type=template&id=52082842&scoped=true&"
import script from "./WriteStep.vue?vue&type=script&lang=js&"
export * from "./WriteStep.vue?vue&type=script&lang=js&"
import style0 from "./WriteStep.vue?vue&type=style&index=0&id=52082842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52082842",
  null
  
)

export default component.exports